// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2ff63cb8","677":"4faa2f0d"}[chunkId] + ".chunk.js";
};